import { Platform, StyleSheet } from "react-native";
import { fonts } from "../../../styles/theme";

const PersonalDetailsStyle = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 20,
    paddingVertical: 10,
    backgroundColor: "#fff",
  },
  scrollContainer: {
    paddingBottom: 20,
    paddingTop: 10,
  },
  viewContainer: {
    paddingBottom: 20,
  },
  label: {
    marginBottom: 8,
    fontSize: 12,
    color: "#979797",
    //fontWeight: "600",
    fontFamily: fonts.regular,
  },
  input: {
    height: 45,
    borderWidth: 1,
    borderRadius: 15,
    paddingHorizontal: 12,
    fontSize: 14,
    color: "#343434",
    marginBottom: 10,
    //fontWeight: "600",
    borderColor: "#CBCBCB",
    fontFamily: fonts.regular,
  },
  switchContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginLeft: "auto",
  },
  button: {
    backgroundColor: "#3629B7",
    borderRadius: 10,
    padding: 15,
    alignItems: "center",
    marginTop: 10,
  },
  buttonText: {
    color: "#fff",
    fontSize: 16,
    //fontWeight: "600",
    fontFamily: fonts.medium,
  },
  disabledInput: {
    backgroundColor: "#f0f0f0",
    color: "#999",
  },
  errorBorder: {
    borderColor: "red",
  },
  errorText: {
    fontSize: 12,
    color: "red",
    marginBottom: 10,
    fontFamily: fonts.regular,
  },
  subHeaderContainer: {
    display: "flex",
    flexDirection: "row",
    gap: 7,
    alignItems: "center",
    marginTop: Platform.OS === "ios" ? 0 : 8,
    marginBottom: Platform.OS === "ios" ? 3 : 3,
  },
});
export default PersonalDetailsStyle;
